import { render, staticRenderFns } from "./DateBadge.vue?vue&type=template&id=64f60a2f&scoped=true&"
import script from "./DateBadge.vue?vue&type=script&lang=js&"
export * from "./DateBadge.vue?vue&type=script&lang=js&"
import style0 from "./DateBadge.vue?vue&type=style&index=0&id=64f60a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f60a2f",
  null
  
)

export default component.exports